const COUNTRY_MAP = {
  'usa': 'United States', 'us': 'United States', 'u.s.a': 'United States', 'u.s.a.': 'United States',
  'u.s': 'United States', 'u.s.': 'United States', 'united states': 'United States',
  'united states of america': 'United States', 'america': 'United States',
  'uk': 'United Kingdom', 'u.k': 'United Kingdom', 'u.k.': 'United Kingdom',
  'united kingdom': 'United Kingdom', 'england': 'United Kingdom', 'scotland': 'United Kingdom',
  'wales': 'United Kingdom', 'great britain': 'United Kingdom', 'britain': 'United Kingdom',
  'ireland': 'Ireland', 'new zealand': 'New Zealand', 'nz': 'New Zealand',
  'canada': 'Canada', 'germany': 'Germany', 'france': 'France', 'spain': 'Spain', 'italy': 'Italy',
  'china': 'China', 'india': 'India', 'japan': 'Japan', 'philippines': 'Philippines',
  'indonesia': 'Indonesia', 'netherlands': 'Netherlands', 'belgium': 'Belgium', 'sweden': 'Sweden',
  'norway': 'Norway', 'denmark': 'Denmark', 'switzerland': 'Switzerland', 'austria': 'Austria',
  'portugal': 'Portugal', 'greece': 'Greece', 'poland': 'Poland', 'brazil': 'Brazil',
  'mexico': 'Mexico', 'singapore': 'Singapore', 'malaysia': 'Malaysia', 'thailand': 'Thailand',
  'vietnam': 'Vietnam', 'south africa': 'South Africa', 'nigeria': 'Nigeria', 'kenya': 'Kenya',
  'uae': 'United Arab Emirates', 'dubai': 'United Arab Emirates', 'hong kong': 'Hong Kong',
  'south korea': 'South Korea', 'korea': 'South Korea', 'russia': 'Russia', 'ukraine': 'Ukraine',
  'turkey': 'Turkey', 'israel': 'Israel', 'argentina': 'Argentina', 'chile': 'Chile',
  'colombia': 'Colombia', 'pakistan': 'Pakistan', 'bangladesh': 'Bangladesh', 'sri lanka': 'Sri Lanka',
  'australia': 'Australia'
};

// Returns the normalized country name if text is a country, otherwise null
export const detectCountryName = (text) => {
  if (!text) return null;
  return COUNTRY_MAP[text.trim().toLowerCase()] || null;
};
